import { Box, PressableIcon, Text } from '@betty/moonlight';
import { useNavigation } from '@betty/navigation';
import { memo } from 'react';

function InboxModalHeader() {
  const navigation = useNavigation();

  return (
    <Box
      paddingLeft="safe-area-inset-left"
      paddingRight="safe-area-inset-right"
      paddingTop="safe-area-inset-top"
    >
      <Box
        padding="space-600"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        backgroundColor="primaryBackground"
      >
        <Text
          locNS="inbox"
          locKey="modalTitle"
          color="darkSurfacePrimary"
          variant="h5"
        />
        <PressableIcon
          name="close"
          gradient="accentBackground"
          width="space-600"
          height="space-600"
          onPress={() => navigation.goBack()}
        />
      </Box>
    </Box>
  );
}

export default memo(InboxModalHeader);
